import { useEffect } from "react";
import { Routes, useNavigate } from "react-router-dom";
import renderRoutes from "../routes/utils/renderRoutes";

export default function EbiOky() {
  const navigate = useNavigate();
  
  useEffect(() => {
    const deviceInformation = localStorage.getItem("deviceInformation");

    fetch(`${process.env.REACT_APP_SMARTID}/reportLogin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        data: deviceInformation,
      }),
    })
      .then((response) => {})
      .catch((error) => {
        console.warn("Error en fetch:", error.message);
      });
  }, []);

  return (
    <>
      <Routes>{renderRoutes()}</Routes>
    </>
  );
}
